"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTheme = void 0;
const styles_1 = require("@material-ui/core/styles");
exports.createTheme = styles_1.createTheme;
//# sourceMappingURL=createMuiTheme.js.map